<template>
  <div class="header">
    <top-ad></top-ad>
    <top-nav></top-nav>
    <middle-search></middle-search>
    <bottom-nav></bottom-nav>
  </div>
</template>

<script>
import TopAd from './TopAd'
import TopNav from './TopNav'
import MiddleSearch from './MiddleSearch'
import BottomNav from './BottomNav'
export default {
  name: 'index',
  components: {
    TopAd,
    TopNav,
    MiddleSearch,
    BottomNav
  }
}
</script>

<style lang="less" scoped>
</style>
